import { Suspense } from "react";
import { AllHireTalentRoutes } from ".";
import Loader from "../../components/loader";
import { Routes, Route, useLocation } from "react-router-dom";

const HireTalentRoutes = () => {
  const location = useLocation();

  return (
    <Suspense fallback={<Loader />}>
      <Routes location={location} key={location.pathname}>
        {AllHireTalentRoutes?.map((item, index) => {
          return (
            <Route key={index} exact path={item.path} element={item?.element} />
          );
        })}

        {/* <Route exact path="*" element={<PageNotFound />} /> */}
      </Routes>
    </Suspense>
  );
};

export default HireTalentRoutes;
